export function validateCandleMagnitude(data) {
  if (
    data.usePivotsAsTrails &&
    (data.initialStop === 'NONE' || data.firstTargetStop === 'NONE') &&
    data.initialStop !== data.firstTargetStop
  )
    return [
      false,
      'Either Initial Stop and or First Target Stop is set to NONE, while the other is not set.',
    ];
  if (!data.candleDuration || isNaN(data.candleDuration)) {
    return [false, 'Candle Duration not valid.'];
  }
  if (!data.numberOfPivots || isNaN(data.numberOfPivots)) {
    if (data.usePivotsAsTrails) {
      return [false, 'Number of pivots set to 0.'];
    }
  }
  if (data.usePivotsAsTrails) {
    if (
      !data.qtyPctPerPivot ||
      (data.qtyPctPerPivot.length == 0 && data.numberOfPivots == 0)
    ) {
      return [false, 'No targets or pivots given.'];
    }
  }
  if (!data.qtyPctPerPivot || data.qtyPctPerPivot.length == 0) {
    if (!data.usePivotsAsTrails) {
      return [
        (false,
        'Use Pivots as Trail is set to false, but there is no quantity per pivot taken.'),
      ];
    }
  }
  for (const qty of data.qtyPctPerPivot) {
    if (isNaN(qty)) {
      return [
        false,
        ' There are values in the qty per pivot array that are not numbers. ',
      ];
    }
  }
  if (!data.timeUnit) {
    return [false, ' No time unit provided.'];
  }
  if (!data.exitInPivotCandle) {
    if (data.usePivotsAsTrails) {
      return [false, 'Exit in Pivot Candle not provided.'];
    }
  }
  if (
    data.generateFromAtrWhenNoPivots &&
    data.pctAtrGenerateAtrWhenNoPivots == 0
  ) {
    return [false, 'Extend Pivots w/ATR cannot be set to 0%'];
  }

  return [true, ''];
}
